import { type ComponentProps } from 'react';
import { MenuButton } from '@headlessui/react';
import clsx from 'clsx';

import styles from './Dropdown.module.css';

type DropdownButtonProps = ComponentProps<typeof MenuButton>;

export default function DropdownButton({ className, children, ...props }: DropdownButtonProps) {
  return (
    <MenuButton
      className={clsx(styles.dropdownButton, className)}
      {...props}
    >
      {children}
    </MenuButton>
  );
}
